<template>
  <view-form :edit="edit" @cancel="backToList" />
</template>

<script>
import ViewForm from '@/components/forms/ViewForm';

// @vuese
// Formularz do edycji widoków
// @group View
export default {
  components: { ViewForm },
  props: {
    // Czy pobierać dane do formularza
    edit: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    // @vuese
    // Powrót do listy widoków
    backToList() {
      this.$router.push({ name: 'views' });
    }
  }
};
</script>
